module.exports = __webpack_public_path__ + "static/pioneering_karel_bossart.6b37545a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_stories/_pioneering/pioneering_karel_bossart.jpg
// module id = 913
// module chunks = 245299024737959